module.exports = __webpack_public_path__ + "img/local-17.a6bddf5b.jpg";